import { makeStyles } from 'tss-react/mui';

export default makeStyles()(() => ({
    paper: {
        padding: 40
    }
}));
